export interface Category {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export interface TickerItem {
  tag: string;
  text: string;
}

export const siteName = "黑料八卦网";

export const siteTagline = "爆料 · 内幕 · 猛料 · 起底";

export const contactEmail = "qunnei@heiliaobagua.example.com";

export const categories: Category[] = [
  { slug: "film", name: "影视", desc: "剧组动态、合同纠纷、选角与番位的幕后博弈", icon: "ri-movie-2-line", count: 42 },
  { slug: "variety", name: "综艺", desc: "剪辑逻辑、阵容调整、口碑起伏的成因拆解", icon: "ri-live-line", count: 31 },
  { slug: "music", name: "音乐", desc: "经纪合约、巡演运作、分账与解约的真实走向", icon: "ri-music-2-line", count: 27 },
  { slug: "influencer", name: "网红", desc: "直播生态、账号归属、内容团队的合作与散伙", icon: "ri-vidicon-line", count: 38 },
  { slug: "emotion", name: "情感", desc: "同框与传闻的逐条拆解，不把巧合当证据", icon: "ri-heart-3-line", count: 19 },
  { slug: "business", name: "商业", desc: "代言、商务合作里那些被忽略的条款细节", icon: "ri-briefcase-4-line", count: 24 },
];

export const tickerItems: TickerItem[] = [
  { tag: "跟踪", text: "未播剧集换角风波进入第二轮协商，补拍通告已更新" },
  { tag: "回应", text: "某综艺导演组就口碑争议发声：承认剪辑存在取舍" },
  { tag: "更新", text: "选秀歌手解约案进入调解，补充协议效力成焦点" },
  { tag: "辟谣", text: "「同款外套」传闻被证实为当季热销单品，重复率偏高" },
  { tag: "进展", text: "巡演取消事件主办方补充说明退票时间表" },
  { tag: "观察", text: "内容团队出走事件引发行业对账号权属的集中讨论" },
];

export const faqItems: FaqItem[] = [
  {
    q: "黑料八卦网的内容来源是什么？",
    a: "我们的内容来自公开声明、公告文件、可交叉验证的行程信息和行业通行惯例。所有事件梳理都会标注可核查的线索方向，涉及具体人物时一律以匿名方式表述，不做未经证实的定性。",
  },
  {
    q: "为什么很多人物都用「某艺人」「某剧组」来称呼？",
    a: "这是我们对内容原则的坚持。在证据链不完整的情况下，点名会造成不可逆的伤害。用匿名表述既能讲清楚事件的来龙去脉，也能避免把推测当成事实传播。",
  },
  {
    q: "「证据链」板块具体包含什么？",
    a: "证据链是我们对可验证信息的整理，通常包括时间节点、公告原文摘要、数据统计结论和多方表述的差异点。它不是结论，而是让读者自己判断的材料基础。",
  },
  {
    q: "内容的更新频率是怎样的？",
    a: "热点事件我们会持续跟踪并更新同一篇内容的进展，而不是重复发稿。深度深扒内容通常每周推出两到三篇，具体取决于线索的核实进度。",
  },
  {
    q: "普通人可以投稿线索吗？",
    a: "可以。我们欢迎来自行业从业者和知情者的线索，投稿时请尽量提供可核查的材料。我们会先做基础核实，确认后再决定是否成稿，不会直接发布未经核实的内容。",
  },
  {
    q: "订阅之后会收到什么？",
    a: "订阅后你会收到每周一期的深扒精选，包含本周最值得细读的三篇内容和一条独家线索进展。我们不会发送与内容无关的推广信息，也可以随时取消。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "林一诺",
    role: "从业七年的影视制片",
    text: "很少见到把合同条款讲得这么清楚的八卦账号。它不急着下结论，而是把材料一条条摆出来，这点在行业里很难得。",
  },
  {
    name: "陈子航",
    role: "长期关注娱乐行业的法务从业者",
    text: "分类页和证据链的设计挺专业，时间线对普通人理解事件帮助很大。希望能一直保持不点名、不站队的克制。",
  },
  {
    name: "苏晚",
    role: "内容行业观察者",
    text: "以前吃瓜全靠刷热点，看完就忘。这里更像是把一件事的来龙去脉整理成一份档案，读完之后确实明白很多。",
  },
  {
    name: "周牧",
    role: "每周必读的老读者",
    text: "订阅半年了，最打动我的是它对未证实传闻的处理方式。宁可写得慢一点，也不轻易给定性，这点很加分。",
  },
];

export const principles = [
  { icon: "ri-file-shield-2-line", title: "可核查优先", text: "没有可交叉验证的材料来源，我们宁可不写，也不抢先发一条未经核实的爆料。" },
  { icon: "ri-user-unfollow-line", title: "匿名表述", text: "在证据链不完整时一律匿名化处理，避免把推测变成对他人的定性伤害。" },
  { icon: "ri-git-branch-line", title: "讲脉络而非结论", text: "把时间线、成因和各方表述摆清楚，让读者拥有自己判断的空间。" },
  { icon: "ri-refresh-line", title: "持续更新", text: "同一事件只做一篇深度内容，后续进展在原稿上更新，而不是重复发稿刷存在感。" },
];

export const stats = [
  { value: "1,280+", label: "累计深扒内容" },
  { value: "6", label: "内容分类" },
  { value: "96%", label: "读者留存率" },
  { value: "每周 2 期", label: "精选推送" },
];